export default __webpack_public_path__ + "static/media/TF_05.8dc124b8.png";